import {Component, ElementRef, inject, OnInit} from '@angular/core';
import {FormFieldComponent} from '../../shared/components/form-field/form-field.component';
import {Perfil} from '../../shared/model/perfil/perfil.model';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FormsModule} from '@angular/forms';
import {ButtonPadraoComponent} from '../../shared/components/button-padrao/button-padrao.component';
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {ValidacaoAlteracaoCampoService} from '../../shared/service/utilitarios/validacao-alteracao-campo.service';

@Component({
  selector: 'app-modal-cadastro-perfil',
  standalone: true,
  imports: [
    FormFieldComponent,
    FormsModule,
    ButtonPadraoComponent,
    MatSlideToggle
  ],
  templateUrl: './modal-cadastro-perfil.component.html',
  styleUrl: './modal-cadastro-perfil.component.css'
})
export class ModalCadastroPerfilComponent implements OnInit {

  perfil: Perfil = new Perfil();

  private readonly dialog = inject<MatDialogRef<ModalCadastroPerfilComponent>>(MatDialogRef);
  private readonly matDialog = inject(MatDialog);
  private readonly elementRef = inject(ElementRef);
  public data = inject(MAT_DIALOG_DATA);
  public alteracaoService = inject(ValidacaoAlteracaoCampoService);

  ngOnInit() {
    this.perfil = this.data['perfil'];
    if(!this.perfil.id){
      this.perfil.ativo = true;
    }
    this.alteracaoService.camposNaoAlterados();
  }

  salvar() {
    this.dialog.close(this.perfil);
  }

  cancelar() {
    this.dialog.close();
  }

}
